import React from "react";
import Reveal from "./Reveal";
import { ASSETS } from "../mock";

const SummerGift = () => {
  return (
    <section
      id="summer-gift"
      data-testid="summer-gift-section"
      className="bg-white py-24 lg:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <Reveal>
          <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
            Summer Offer
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
            Book Your Summer Escape &amp; Receive a{" "}
            <span className="gold-text italic">Special Gift</span>
          </h2>
        </Reveal>
        <Reveal className="mt-14" delay={0.1}>
          <div className="relative inline-block">
            <div className="absolute -top-5 -left-5 w-full h-full border border-[#B88A3B]/30 hidden sm:block" />
            <img
              alt="Exclusive Marbella Consulting goodies: gift bags, souvenirs and hand fan"
              className="relative w-full h-auto max-w-3xl"
              src={ASSETS.summerGift}
            />
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <a
            href="#contact"
            className="inline-block mt-12 bg-[#B88A3B] text-white px-8 py-4 uppercase tracking-[0.2em] text-sm font-medium hover:bg-[#C09245] hover:-translate-y-1 transition-[background-color,transform] duration-300"
          >
            Book Your Escape
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default SummerGift;
